export default {
    appsflyer: true
};